import { Container, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { blue, green, purple } from '@material-ui/core/colors';
import axios from 'axios';
import { React, useEffect, useState } from 'react';
import * as API from '../../api/index';
import Mpesa from '../../payments/mpesa/mpesa';
import ReactPaypal from '../../payments/paypal/paypal';
import { MultibetsHeader, PaymentBoxHeader, PaymentTitle, SelectPaper, SelectTitle, StyledBox, StyledHeading, StyledMultibetBox, StyledMultibetGamesBox, StyledParagraph, StyledPaymentBox, StyledPaymentPaper, StyledSection } from '../styles/global-style';
import GamesTable from './vip_table';


const Multibets = () => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
    const [sub, setSub] = useState('')
    const username = user?.user.username

    // subscriptions 
    const [iuser, setI2] = useState(false);
    const [ouser, setOvund] = useState(false);
    const [guser, setGG] = useState(false);
    const [huser, setHTFT] = useState(false);

    // games
    const [ix2g, set12Games] = useState([]);
    const [ggames, setGGGames] = useState([]);
    const [ougames, setOVGames] = useState([]);
    const [hfgames, setHfGames] = useState([]);



    useEffect(() => {
        document.title = 'Multibets | 1X2 Multibets | GG Multibets | Over/Under Multibets | HT/FT Multibets'
        getGames();
        getUser();
    }, [])

    const getUser = async () => {
        await API.Ix2Subscribers(username).then(
            (response) => setI2(response.data[0].Ix2)

        ).catch((error)=>console.log(error));

        await API.ggSubscribers(username).then(
            (response) => setGG(response.data[0].gg) //console.log('resposnseeee issssss', response.data[0].gg) //

        ).catch((error)=>console.log(error));

        await API.ovundSubscribers(username).then(
            (response) => setOvund(response.data[0].ovund)

        ).catch((error)=>console.log(error));

        await API.hftSubscribers(username).then(
            (response) => setHTFT(response.data[0].htft)

        ).catch((error)=>console.log(error));

    }


    const getGames = async () => {
        const ix2Games = API.multibetGames('12');
        const ggGames = API.multibetGames('GG');
        const ovGames = API.multibetGames('OU');
        const htGames = API.multibetGames('HF');

        await axios.all([ix2Games, ggGames, ovGames, htGames]).
            then(
                axios.spread((i2, gg, ov, hf) => {

                    console.log('games aree', i2, gg, ov, hf)
                    set12Games(i2.data[0].games);
                    setGGGames(gg.data[0].games);
                    setOVGames(ov.data[0].games);
                    setHfGames(hf.data[0].games);
                })
            ).catch((errors) =>
                console.log(errors)
            )

    }


    const handleChange = (event) => {
        const { target: { value: _value } } = event;
        setSub(_value)
    }
    return (
        <Container align='center'>
            <StyledBox align='justify'>
                <StyledHeading variant='h5' >Multibets Predictions</StyledHeading>

                <StyledParagraph variant='caption'>
                    Multi bets tips are correct predictions with an evarage accuracy of 90%. This page displays <b>Multibet predictions </b>
                    for betting markets like <b>1X2</b>, <b>GG</b>, <b>OVER/UNDER</b> and the <b>Half Time | Full Time </b> multibets.
                    To access multibet of your choice, <b>Book now</b> and win big with these multibet predictions.
                </StyledParagraph>
            </StyledBox>
            <StyledSection>
                <StyledMultibetBox>
                    <StyledMultibetGamesBox>
                        <MultibetsHeader>1X2 Multibets</MultibetsHeader>
                        <GamesTable subscribed={iuser} games={ix2g} />
                    </StyledMultibetGamesBox>

                    <StyledMultibetGamesBox>
                        <MultibetsHeader>GG Multibets</MultibetsHeader>
                        <GamesTable subscribed={guser} games={ggames} />
                    </StyledMultibetGamesBox>

                    <StyledMultibetGamesBox>
                        <MultibetsHeader>Over/Under Multibets</MultibetsHeader>
                        <GamesTable subscribed={ouser} games={ougames} />
                    </StyledMultibetGamesBox>

                    <StyledMultibetGamesBox>
                        <MultibetsHeader>Half/Full Time Multibets</MultibetsHeader>
                        <GamesTable subscribed={huser} games={hfgames} />
                    </StyledMultibetGamesBox>


                </StyledMultibetBox>
                <StyledPaymentPaper>
                    <StyledPaymentBox >
                        <PaymentBoxHeader variant='h5'>Book Now</PaymentBoxHeader>
                        <SelectPaper>
                            <SelectTitle>Select a multibet to book </SelectTitle>
                            <RadioGroup onChange={handleChange} >
                                <FormControlLabel value='1X2' control={<Radio />} label='1X2 Multibets' />
                                <FormControlLabel value='GG' control={<Radio />} label='GG Multibets' />
                                <FormControlLabel value='OV' control={<Radio />} label='OVER | UNDER Multibets' />
                                <FormControlLabel value='HTFT' control={<Radio />} label='HT | FT Multibets' />
                            </RadioGroup>

                        </SelectPaper>
                        {sub !== '' ?
                            <>
                                <PaymentTitle mleft={10} textcolor={green[900]}>Pay with Mpesa</PaymentTitle>
                                <Mpesa price={200} product={sub} />
                                <PaymentTitle mleft={10} textcolor={purple[900]}>Pay with PayPal</PaymentTitle>
                                <ReactPaypal price={2.0} product={sub} />
                            </>
                            :
                            <PaymentTitle mleft={10} textcolor={blue[900]}>Please Select a multibet above</PaymentTitle>

                        }
                    </StyledPaymentBox>
                </StyledPaymentPaper>
            </StyledSection>


        </Container>
    );
};

export default Multibets;
